import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { label: t('nav.home'), to: '/' },
    { label: t('nav.services'), to: '/services' },
    { label: t('nav.about'), to: '/about' },
    { label: t('nav.contact'), to: '/contact' },
  ];

  const services = t('footer.services', { returnObjects: true }) as string[];

  return (
    <footer className="bg-foreground-900 text-background-50/70">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-shining-line text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">Limpia</span>
            </Link>
            <p className="text-sm leading-relaxed mb-5">{t('footer.tagline')}</p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-50/60 hover:text-background-50 hover:bg-primary-500 transition-all cursor-pointer" aria-label="Facebook">
                <i className="ri-facebook-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-50/60 hover:text-background-50 hover:bg-primary-500 transition-all cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-50/60 hover:text-background-50 hover:bg-primary-500 transition-all cursor-pointer" aria-label="LinkedIn">
                <i className="ri-linkedin-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{t('footer.quickLinks')}</h4>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{t('footer.ourServices')}</h4>
            <ul className="flex flex-col gap-2.5">
              {services.map((item) => (
                <li key={item}>
                  <span className="text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{t('footer.contactInfo')}</h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-primary-400">
                  <i className="ri-map-pin-line text-sm"></i>
                </div>
                <span className="text-sm">{t('footer.address')}</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-primary-400">
                  <i className="ri-phone-line text-sm"></i>
                </div>
                <div className="flex flex-col gap-1">
                  <a href="tel:+41264361083" className="text-sm hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">+41 26 436 10 83</a>
                  <a href="tel:+41798877252" className="text-sm hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">+41 79 887 72 52</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-primary-400">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                <a href="mailto:info@limpiasarl.ch" className="text-sm hover:text-primary-400 transition-colors cursor-pointer">info@limpiasarl.ch</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs">&copy; {new Date().getFullYear()} Limpia Sàrl. {t('footer.rights')}</p>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="text-xs hover:text-primary-400 transition-colors cursor-pointer">{t('footer.privacy')}</Link>
            <Link to="/terms" className="text-xs hover:text-primary-400 transition-colors cursor-pointer">{t('footer.terms')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}